/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { cardIssuingRequest } from "../../funcs/cardIssuingRequest.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RequestCardRequest$inboundSchema,
};

export const tool$cardIssuingRequest: ToolDefinition<typeof args> = {
  name: "card-issuing-request",
  description: `Request a virtual card be issued.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/issued-cards.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await cardIssuingRequest(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
